import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import { memoizeFunction } from "@fluentui/react/lib/Utilities";

import type { ActionControlSize } from "@1js/acui-common";

import type { AppLabelStyles } from "./AppLabel.Props";

export interface LabelSizedStyles {
  styles?: Partial<AppLabelStyles>;
}

const labelSmallStyles: Partial<AppLabelStyles> = {
  root: {
    paddingLeft: 0,
  },
  label: {
    fontSize: 12,
  },
};

export const getLabelSizedStyles = memoizeFunction(
  (
    size: ActionControlSize | undefined,
    externalStyles: Partial<AppLabelStyles> | undefined
  ): LabelSizedStyles => {
    return size
      ? { styles: mergeStyleSets(labelSmallStyles, externalStyles) }
      : {};
  }
);
